import React from "react";

import "./LocaleFlag.scss";
import { ImgStore } from "../../../elements/ImgStore/ImgStore";

const getClassName = (...items)=>items.filter(Boolean).join(" ");

export const LocaleFlag = (props)=>{
    const { className, label, locale, selected=false } = props;
    const value = String(locale ?? "").trim().toLowerCase();

    return (
        <ImgStore
            alt={label || value.toUpperCase()}
            className={getClassName("LocaleFlag", selected && "isSelected", className)}
            src={`flag${String.jet.capitalize(value)}.webp`}
        />
    );
};
